import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-status-block',
  templateUrl: './status-block.component.html',
  styleUrls: ['./status-block.component.scss'],
  standalone: false
})
export class StatusBlockComponent  {

  @Input()
  bg: string;

  @Input()
  bgDarker: string;

  @Input()
  title: string;

  @Input()
  text: string;

}
